import { render } from "./BasicBoard.vue?vue&type=template&id=8c302b60"
import script from "./BasicBoard.vue?vue&type=script&lang=js"
export * from "./BasicBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__